
export const editMutations = <const>{
	VOZIDLO_ZAKAZNIK_SELECT_MAPPER: 'VOZIDLO_ZAKAZNIK_SELECT_MAPPER',
	VOZIDLO_MODEL_SELECT_MAPPER: 'VOZIDLO_MODEL_SELECT_MAPPER',
	VOZIDLO_BARVA_SELECT_MAPPER: 'VOZIDLO_BARVA_SELECT_MAPPER',
	VOZIDLO_PRODEJCE_SELECT_MAPPER: 'VOZIDLO_PRODEJCE_SELECT_MAPPER',
	VOZIDLO_KONTAKT_MERGE_DATA: 'vozidloKonMerge',
	VOZIDLO_TYP_KOD_CHANGE: 'typKodChange',
	VOZIDLO_POJISTOVNA_SELECT_MAPPER: 'VOZIDLO_POJISTOVNA_SELECT_MAPPER',
	VOZIDLO_LEASING_SELECT_MAPPER: 'VOZIDLO_LEASING_SELECT_MAPPER',
	MAP_CDB_VOZIDLO: 'mapCDBVozidlo',
};
export const editActions = <const>{
	VOZIDLO_TYP_KOD_SELECT_MAPPER: 'VOZIDLO_TYP_KOD_SELECT_MAPPER',
	SET_CDB_VOZIDLO: 'setCDBVozidlo',
};

export const listMutations = <const>{
	VOZIDLO_ZAKAZNIK_FILTER_SELECT_MAPPER: 'VOZIDLO_ZAKAZNIK_FILTER_SELECT_MAPPER',
	VOZIDLO_LEASING_ZAKAZNIK_FILTER_SELECT_MAPPER: 'VOZIDLO_LEASING_ZAKAZNIK_FILTER_SELECT_MAPPER',
	VOZIDLO_POJISTOVNA_FILTER_SELECT_MAPPER: 'VOZIDLO_POJISTOVNA_FILTER_SELECT_MAPPER',
};

export const mergeActions = <const>{
	GET_VOZIDLO: 'GET_VOZIDLO',
};
